import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCaretDown = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 11,
	height: 6,
	viewBox: "0 0 11 6",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M5.02836 5.80979C5.09028 5.87009 5.1638 5.91793 5.24472 5.95056C5.32565 5.9832 5.4124 6 5.5 6C5.5876 6 5.67435 5.9832 5.75528 5.95056C5.8362 5.91793 5.90972 5.87009 5.97163 5.80979L10.8046 1.10777C10.9297 0.986073 11 0.821018 11 0.648915C11 0.476812 10.9297 0.311758 10.8046 0.190063C10.6796 0.0683676 10.5099 4.05489e-09 10.333 0C10.1561 -4.05489e-09 9.98646 0.0683676 9.86137 0.190063L5.5 4.43323L1.13863 0.190063C1.07669 0.129805 1.00316 0.0820068 0.92224 0.0493957C0.841316 0.0167847 0.754583 1.26983e-09 0.666992 0C0.579402 -1.26983e-09 0.492669 0.0167847 0.411745 0.0493957C0.330822 0.0820068 0.257294 0.129805 0.195358 0.190063C0.133422 0.25032 0.0842913 0.321856 0.0507718 0.400586C0.0172523 0.479316 -1.3052e-09 0.563698 0 0.648915C1.3052e-09 0.734132 0.0172523 0.818514 0.0507718 0.897244C0.0842913 0.975974 0.133422 1.04751 0.195358 1.10777L5.02836 5.80979Z",
		fill: "#797979"
	})
});
export default SvgCaretDown;
